import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Tab, Tabs, Typography, useTheme,
} from '@mui/material';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { KeyboardArrowDown } from '@mui/icons-material';
import analytics from '../../utils/analytics';
import AlertDialog from '../AlertDialog';

type StyledTabsProps = {
    children?: React.ReactNode;
    value: number|false;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
  }
type StyledTabProps = {
  label: string;
}
export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
      // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
))(({ theme }) => ({
  '& .MuiButtonBase-root.Mui-selected': {
    color: theme.palette.secondary.main,
  },
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));

export const StyledTab = styled((props: StyledTabProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Tab disableRipple {...props} icon={<KeyboardArrowDown />} iconPosition="end" />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(16),
  marginLeft: theme.spacing(1),
  color: theme.palette.black.main,
  paddingBottom: 0,
  transition: '0.5s',
  '&:hover': {
    color: 'inherit',

  },
  '& .MuiTab-iconWrapper': {
    transition: '1s',
    '&:hover': {
      paddingBottom: 5,
    },
  },
}));

export const mobileIcons = (tabValue:string):{[key:string]:React.ReactElement} => {
  const theme = useTheme();
  const buttonStyle = (value:string) => (
    {
      color: tabValue === value ? theme.palette.secondary.main : undefined,
      paddingBottom: '6px',
      fontSize: '22px',
    }
  );
  return (
    {
      Créditos: <CreditCardIcon
        style={buttonStyle('Créditos')}
      />,
      Inversiones: <BarChartIcon
        style={buttonStyle('Inversiones')}
      />,
      Pagos: <AccountBalanceIcon
        style={buttonStyle('Pagos')}
      />,
      BNPL: <ShoppingBagOutlinedIcon
        style={buttonStyle('BNPL')}
      />,
    });
};

const creditos = { label: 'Créditos', url: '/account', mobileIcon: CreditCardIcon };
const inversiones = { label: 'Inversiones', url: '/account/investment', mobileIcon: BarChartIcon };
const pagos = { label: 'Pagos', url: '/account/pac', mobileIcon: AccountBalanceIcon };
const bnpl = { label: 'Compras', url: '/account/bnpl', mobileIcon: ShoppingBagOutlinedIcon };

export const totalTabs = [creditos, bnpl, pagos];
export const baseTabs = [bnpl, pagos];
export const totalTabsWithInvestments = [creditos, bnpl, inversiones, pagos];
export const baseTabsWithInvestments = [bnpl, inversiones, pagos];

export function logOut() {
  analytics.track('Click Boton', { text: 'Continuar', initiator: 'usuario' });
  analytics.reset();
  sessionStorage.removeItem('__react_session__');
  window.location.href = '/account/login';
}

export function CloseAlertDialog(props: { button: React.ReactElement }) {
  const { button } = props;
  return (
    <AlertDialog
      dialogTitle={(
        <Typography
          fontWeight="bold"
          variant="h6"
          component="div"
          align="center"
        >
          ¿Cerrar sesión?
        </Typography>
      )}
      dialogContent="Si presiona continuar, se redirigirá a la vista de inicio de sesión"
      action={() => logOut()}
      button={button}
      pageCall={{ category: 'PU - LOGOUT', name: 'CONFIRMAR LOGOUT' }}
    />
  );
}
